document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".initially-hidden").forEach((el) => {
    el.classList.remove("initially-hidden");
  });

    const header = document.querySelector(".main-header");
    const announcement = document.querySelector(".section-announcement-bar");

    const root = document.documentElement;

    if (header) {
      const headerHeight = header.offsetHeight;
      root.style.setProperty("--header-height", `${headerHeight}px`);
    } else {
      root.style.setProperty("--header-height", "0px");
    }

    if (announcement) {
      const announcementHeight = announcement.offsetHeight;
      root.style.setProperty("--announcement-height", `${announcementHeight}px`);
    } else {
      root.style.setProperty("--announcement-height", "0px");
    }
  initializeLazyImages();
});

// Global lazy image loader with skeleton backgrounds
function initializeLazyImages() {
  const lazyImages = document.querySelectorAll(".lazy-fade");

  if (!lazyImages.length) return;

  lazyImages.forEach((img) => {
    // Add skeleton class to wrapper
    const wrapper = img.closest(".lazy-wrapper");
    if (wrapper) {
      wrapper.classList.add("loading");
    }

    // Check if already loaded
    if (img.complete && img.naturalHeight !== 0) {
      handleImageLoad(img, wrapper);
    } else {
      // Listen for load event
      img.addEventListener("load", function () {
        handleImageLoad(img, wrapper);
      });

      // Handle error
      img.addEventListener("error", function () {
        if (wrapper) {
          wrapper.classList.remove("loading");
          wrapper.classList.add("error");
        }
      });
    }
  });
}

function handleImageLoad(img, wrapper) {
  img.classList.add("loaded");
  if (wrapper) {
    wrapper.classList.remove("loading");
    wrapper.classList.add("loaded");
  }
}

function debounce(fn, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

function throttle(func, limit) {
  let lastFunc;
  let lastRan;
  return function () {
    const context = this;
    const args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(() => {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
}

// Scroll to Top Button
function initializeScrollToTop() {
  const scrollToTopBtn = document.getElementById('scrollToTop');
  if (!scrollToTopBtn) return;

  const outerElement = scrollToTopBtn.querySelector('.scroll-to-top__outer');
  let lastScrollTop = 0;

  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const documentHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrollProgress = documentHeight > 0 ? (scrollTop / documentHeight) * 360 : 0;

    // Show/hide button based on scroll direction
    if (scrollTop > 100) {
      scrollToTopBtn.classList.add('visible');
    } else {
      scrollToTopBtn.classList.remove('visible');
    }

    // Update progress border fill on outer element
    if (outerElement) {
      outerElement.style.setProperty('--scroll-progress', `${scrollProgress}deg`);
    }

    lastScrollTop = scrollTop;
  }

  // Throttled scroll handler
  const throttledScroll = throttle(handleScroll, 16); // ~60fps
  window.addEventListener('scroll', throttledScroll, { passive: true });

  // Initial check
  handleScroll();

  // Click handler to scroll to top
  scrollToTopBtn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
}

// Scroll to reviews section when visiting home with ?q=reviews (home page only)
function scrollToReviewsIfRequested() {
  const pathname = window.location.pathname || "/";


  // ✅ Home page detection:
  // "/" or "/ar/" or "/en/" etc.
  const isHomePage =
  pathname === "/" ||
  /^\/[a-z]{2}\/$/.test(pathname); // matches "/ar/", "/en/", etc.


  if (!isHomePage) return;


  const params = new URLSearchParams(window.location.search);
  const q = params.get("q");


  if (q !== "reviews") return;


  const section = document.getElementById("custom-reviews");
  if (!section) return;


  section.scrollIntoView({ behavior: "smooth", block: "start" });
}

// Initialize scroll to top on DOM ready
document.addEventListener("DOMContentLoaded", () => {
  initializeScrollToTop();
  scrollToReviewsIfRequested();

     function containsArabic(text) {
      // Arabic Unicode range: U+0600 to U+06FF
      const arabicRegex = /[\u0600-\u06FF]/;
      return arabicRegex.test(text);
    }
    
    const articleCards = document.querySelectorAll('.blog__article');
    articleCards.forEach(article => {      
      if (article) {
        const title = article.querySelector('.blog__article-title')
        if (title) {
          if (containsArabic(title.textContent)){
            article.classList.add('rtl')
          }
        }
      }
    })
});
